<template>
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName"  @tab-click="handleClick">
                <el-tab-pane label="用户解锁分类列表" name="user">
                    <User v-if="activeName=='user'"></User>
                </el-tab-pane>
                <el-tab-pane label="激活码列表" name="code">
                    <Code v-if="activeName=='code'"></Code>
                </el-tab-pane>
                <el-tab-pane label="角色列表" name="role">
                    <Role v-if="activeName=='role'"></Role>
                </el-tab-pane>
                <el-tab-pane label="设置" name="setting">
                    <Setting v-if="activeName=='setting'"></Setting>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import User from './user/Index.vue';
    import Code from './code/Index.vue';
    import Role from './role/Index.vue';
    import Setting from './setting/Index.vue';
    export default {
        components: {
            User,
            Code,
            Role,
            Setting
        },
        data() {
            return {
                activeName: 'user',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {
            // 默认
            let tabs = this.$db.getRouteField(this, 'tabs');
            if (tabs) this.activeName = tabs;
        },
        methods: {
            /*切换*/
            handleClick(e) {
                this.activeName = e.name;
                this.$db.setRoute(this, {'tabs': e.name});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/study/code/index.vue